import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FieldDefinitionInfo } from './FieldDefinitionInfo';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type VisibleRowFields_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', fieldsList?: { __typename?: 'ShareFieldConnection', nodes: Array<{ __typename?: 'ShareField', isVisible?: boolean | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, fieldType: Types.FieldTypeEnum, isSystemField: boolean, isSortable?: boolean | null, name: string } | null } | null> } | null };

export type VisibleRowFields_Collection_Fragment = { __typename?: 'Collection', fieldsList?: { __typename?: 'CollectionFieldConnection', nodes: Array<{ __typename?: 'CollectionField', isVisible?: boolean | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, fieldType: Types.FieldTypeEnum, isSystemField: boolean, isSortable?: boolean | null, name: string } | null } | null> } | null };

export type VisibleRowFields_CollectionShare_Fragment = { __typename?: 'CollectionShare', fieldsList?: { __typename?: 'ShareFieldConnection', nodes: Array<{ __typename?: 'ShareField', isVisible?: boolean | null, fieldDefinition?: { __typename?: 'ProjectFieldDefinition', id: string, fieldType: Types.FieldTypeEnum, isSystemField: boolean, isSortable?: boolean | null, name: string } | null } | null> } | null };

export type VisibleRowFieldsFragment = VisibleRowFields_AdHocAssetsShare_Fragment | VisibleRowFields_Collection_Fragment | VisibleRowFields_CollectionShare_Fragment;

export const VisibleRowFields = /*#__PURE__*/ gql`
    fragment VisibleRowFields on AssetAggregate {
  fieldsList(page: {first: 100}) {
    nodes {
      isVisible
      fieldDefinition {
        ...FieldDefinitionInfo
      }
    }
  }
}
    ${FieldDefinitionInfo}` as unknown as DocumentNode<VisibleRowFieldsFragment, unknown>;

        

        
export const useVisibleRowFieldsFragment = (
  input: string | Omit<UseFragmentOptions<VisibleRowFieldsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregate' } };
    return input;
  })();

  return useFragment<VisibleRowFieldsFragment>({
    fragment: VisibleRowFields,
    fragmentName: 'VisibleRowFields',
    ...options,
  });
};
  
        